// import React from 'react';
// import logo from './logo.svg';
import './App.css';
import RecipeBook from './components/recipe_book';

function App() {
  return (
    <div className="App">
      {/* <header className="App-header">
        
      </header> */}
      <main>
        <RecipeBook/>
      </main>
    </div>
  );
}

export default App;
